import { ReactNode } from 'react';

// Hint reveal: hints no longer take permanent vertical space. They show only
// while the user is ON the field — on hover OR keyboard focus (focus-within) —
// as a small overlay anchored below the control, so they never push layout.
// The nearest `group relative` ancestor (a FormField, a Checkbox) is the field.
// The visible overlay is for the eye; screen readers get the sr-only copy the
// control is described by (D4 option A: no visible change).
export function HintOverlay({ hint, className = '' }: { hint: ReactNode; className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute left-0 top-full z-20 mt-1 hidden max-w-xs rounded-md border border-border bg-surface px-2 py-1 text-meta leading-snug text-muted shadow-md group-hover:block group-focus-within:block ${className}`}
    >
      {hint}
    </div>
  );
}
